import React, { FC } from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import AccessTime from '@mui/icons-material/AccessTime';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const PendingView: FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <Box display="flex" alignItems="center" flexDirection="row" px={2} pt={3} justifyContent="center">
        <AccessTime color="warning" sx={{ fontSize: '40px' }} style={{ marginRight: '10px' }} />
        <Typography variant="h3">ORDER PROCESSING...</Typography>
      </Box>
      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <Typography variant="body1">Please wait while we process your order</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
